import getJSONHeaders from "./getJSONHeaders";

/**
 * @param {String} url
 * @param {Object} [params]
 *
 * @return {Promise} Prepared call to native fetch method
 */
export default function fetchJSON(url, params = {}) {
  if ("body" in params) {
    params.body = JSON.stringify(params.body);
  }

  params.headers = getJSONHeaders(params.headers);

  return fetch(url, params);
}
